import { IPriceBandHelper, IProductConfig, Maybe, Price } from '../graphql/schema/p4types';

export const getPriceBands = (productConfig: Maybe<IProductConfig>) => {
  if (!productConfig) return [];
  const priceBands: Array<IPriceBandHelper> = [];

  for (let priceIndex = 1; priceIndex <= 10; priceIndex++) {
    const title = productConfig[`sellingPriceTitle${priceIndex}`];
    if (title) {
      priceBands.push({
        title: title,
        price: `SALES_PRICE_${priceIndex}` as Price,
      });
    }
  }

  return priceBands;
};
